<template>
  <div v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="flex mb-4 justify-end">
          <label class="custom-file-upload">
            <input
              type="file"
              id="file"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              ref="file"
              v-on:change="handleFileUpload"
            />

            <feather-icon
              icon="PaperclipIcon"
              svgClasses="h-4 w-4"
              class="ico"
            />
            <span v-if="!uploadedFileName" class="pr-1">{{
              $t("ChooseFile")
            }}</span>

            <span v-if="uploadedFileName" class="file-name">{{
              uploadedFileName
            }}</span>
          </label>
          <vs-button
            @click="uploadFile"
            class="bg_m_green float-right whitespace-no-wrap"
            v-if="fileUploaded"
            :disabled="disabledUploadButton"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
            {{ $t("UploadFile") }}
          </vs-button>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('SegmentName') },
                { title: $t('SegmentId') },
                { title: $t('Amount') },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 25%">
                  {{ row.segmentName }}
                </td>
                <td style="width: 25%">
                  {{ row.segmentId }}
                </td>
                <td style="width: 25%">
                  {{ row.amount.toLocaleString() }}
                </td>
                <td style="width: 25%">
                  <div class="flex gap-2 items-center justify-center">
                    <router-link
                      v-has-permission="'GetAllSaleAgentTarget'"
                      :to="{
                        path: `/SaleTargets/${$route.params.saleTargetId}/Segments/${row.id}/SaleAgents`,
                        query: { breadcrumbName: row.segmentName },
                      }"
                    >
                      <vs-button
                        color="primary"
                        type="border"
                        icon-pack="feather"
                        icon="icon-edit"
                        class="flex gap-2 px-2 py-1"
                        >{{ $t("Agents") }}</vs-button
                      >
                    </router-link>
                  </div>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  components: {
    DataGrid,
  },
  data() {
    const saleTargetId = this.$route.params.saleTargetId;
    return {
      gridDataSource: {
        type: "app",
        service: `/Sales/api/SaleTargetsQuery/segmentTargets`,
      },
      gridSearchData: {
        saleTargetId: saleTargetId,
      },
      file: {
        name: "",
      },
      fileUploaded: false,
      uploadedFileName: "",
      disabledUploadButton: false,
    };
  },
  methods: {
    ...mapActions({
      deleteSaleTarget: "saleTarget/deleteSaleTarget",
      sendSaleTargetSegmentsExcelFile: "excel/sendSaleTargetSegmentsExcelFile",
    }),
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.uploadedFileName = this.$refs.file.files[0].name;
      this.fileUploaded = true;
    },
    uploadFile() {
      const saleTargetId = this.$route.params.saleTargetId;
      this.disabledUploadButton = true;
      let formData = new FormData();
      formData.append("file", this.file);
      this.sendSaleTargetSegmentsExcelFile({
        file: formData,
        saleTargetId: saleTargetId,
      })
        .then(() => {
          setTimeout(() => {
            this.$refs.grid.renderGrid(1, true);
          }, 500);
          setTimeout(() => {
            this.removeUploadFile();
            this.disabledUploadButton = false;
          }, 1000);
        })
        .catch(() => {
          this.removeUploadFile();
          this.disabledUploadButton = false;
        });
    },
    removeUploadFile() {
      this.file = "";
      this.$refs.file.value = null;
      this.uploadedFileName = "";
      this.fileUploaded = false;
    },
  },
};
</script>
<style scoped>
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 4px 12px 4px 12px;
  cursor: pointer;
}
.file-name {
  padding: 0 0.5rem;
  background-color: #eeeff1;
  position: relative;
  left: -0.65rem;
}
.bg_m_green {
  border-radius: 6px 0 0 6px !important;
  padding: 0.3rem 0.8rem !important;
}
</style>
